export const imageViewerOptions = {
    btnClass: 'default',
    zoomFactor: 0.1,
    wheelZoom: true,
    allowFullscreen: false,
    allowKeyboardNavigation: false,
    btnIcons: {
        zoomIn: 'icofont icofont-ui-zoom-in',
        zoomOut: 'icofont icofont-ui-zoom-out',
        rotateClockwise: 'icofont icofont-refresh',
        rotateCounterClockwise: 'icofont icofont-refresh',
        next: 'icofont icofont-arrow-right',
        prev: 'icofont icofont-arrow-left',
        fullscreen: 'fa fa-arrows-alt'
    },
    btnShow: {
        zoomIn: true,
        zoomOut: true,
        rotateClockwise: true,
        rotateCounterClockwise: true,
        next: false,
        prev: false
    },
    containerBackgroundColor: 'transparent',
    customBtns: [
        {
            name: 'exit',
            icon: 'icofont icofont-ui-close'
        }
    ]
};
